module.exports = __webpack_public_path__ + "img/spartan-build-design-01.846e5cd5.jpg";